import { render, staticRenderFns } from "./RegisterBox.vue?vue&type=template&id=aecb5636"
import script from "./RegisterBox.vue?vue&type=script&lang=ts"
export * from "./RegisterBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports